// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"6093d714","598":"50cebd36","703":"27532069"}[chunkId] + ".chunk.js";
};